import classNames from 'classnames';
import * as PropTypes from 'prop-types';
import React, {CSSProperties, HTMLAttributes, ReactNode} from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';
import colSizeClassesFromProps from 'ui-library/bs/util/colSizeClassesFromProps';

interface ColProps {
  'aria-labelledby'?: string;
  xs?: number;
  sm?: number;
  md?: number;
  lg?: number;
  'xs-offset'?: number;
  'sm-offset'?: number;
  'md-offset'?: number;
  'lg-offset'?: number;
  'xs-push'?: number;
  'sm-push'?: number;
  'md-push'?: number;
  'lg-push'?: number;
  'xs-pull'?: number;
  'sm-pull'?: number;
  'md-pull'?: number;
  'lg-pull'?: number;
  className?: string;
  role?: HTMLAttributes<HTMLDivElement>['role'];
  style?: CSSProperties;
  children?: ReactNode;
  id?: string;
  dataTestAttrs?: DataTestAttrs;
}

function Col(props: ColProps): JSX.Element {
  const colSizeClasses = colSizeClassesFromProps(props);
  const classString = classNames(props.className, colSizeClasses);
  return (
    <div
      aria-labelledby={props['aria-labelledby']}
      className={classString}
      id={props.id}
      role={props.role}
      style={props.style}
      {...getTestProps(props.dataTestAttrs)}
    >
      {props.children}
    </div>
  );
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const propTypes: any = {
  children: PropTypes.node,
  className: PropTypes.string,
  style: PropTypes.object,
};

Col.propTypes = propTypes;

export default Col;
